import { combineReducers } from 'redux'

import job from './job/slice'

const panelReducer = combineReducers({
  job,
})

export default panelReducer
